module.exports = __webpack_public_path__ + "img/IMG_5002_L_Foamcore.9c609e90.jpg";